import React, { useEffect, useState } from 'react';
import {
    Backdrop, CircularProgress, Snackbar, TableRow,
    TableCell, Table, TableHead, TableBody, TableContainer,
    Button, Card, CardHeader, CardContent, Divider,
    IconButton, Tooltip, Grid, Dialog, TextField,
    InputLabel, DialogContent, DialogActions

} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Page from 'src/components/Page';
import Alert from 'src/components/Alert';
import EditIcon from '@material-ui/icons/Edit';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { tr } from 'date-fns/locale';
import { createTheme, ThemeProvider } from '@mui/material';
import Alert2 from '@mui/material/Alert';
import VisibilityIcon from '@mui/icons-material/Visibility';


import axios from 'src/utils/axios';


import CelebrationMessagePreview from 'src/components/CelebrationMessagePreview';
import { set } from 'date-fns';

const theme2 = createTheme({
    palette: {
        primary: {
            main: '#FF9800',
            light: '#FF9800',
            dark: '#FF9800',
        },
    },
});

const useStyles = makeStyles((theme) => ({
    myDatePicker: {
        width: '100%',
    },
}));

const options = [
    { label: "Aktif", value: 1 },
    { label: "Pasif", value: 0 }
];




const CelebrationManagement = () => {
    const classes = useStyles();
    const [loading, setLoading] = React.useState(false);
    const [uyari, setUyari] = React.useState(false);
    const [uyariTip, setUyariTip] = React.useState('success');
    const [responseMessage, setResponseMessage] = React.useState('');
    const uyariKapat = () => {
        setUyari(false);
    }
    const [celebrationData, setCelebrationData] = React.useState([]);

    const [openNewCelebrationDialog, setOpenNewCelebrationDialog] = React.useState(false);

    const [openCelebrationPreviewDialog, setOpenCelebrationPreviewDialog] = React.useState(false);
    const [celebrationMessage, setCelebrationMessage] = React.useState('');

    const [celebrationPostData, setCelebrationPostData] = useState({
        Id: 0,
        Name: '',
        Content: '',
        Status: 1,
        PublishDate: new Date(),
        OrganizationTypeId: 0,
        CreatedOrUpdatedBy: '',
        OperationType: 0
    });


    useEffect(() => {
        GetCelebration();
    }, []);

    const GetCelebration = () => {
        setLoading(true);
        axios.get('GetCelebration')
            .then((response) => {
                if (response.data.length > 0) {
                    setCelebrationData(response.data);
                }
                setLoading(false);
            })
            .catch((error) => {
                setUyariTip('error');
                setResponseMessage('Kutlamalar getirilirken bir hata oluştu.');
                setUyari(true);
                setLoading(false);
            });
    }


    const handlePostDataChange = (e) => {
        debugger;
        const { name, value } = e.target;
        setCelebrationPostData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const onChangeStatus = (e, value) => {
        setCelebrationPostData((prevData) => ({
            ...prevData,
            Status: value.value,
        }));
    };

    const handleNewCelebration = () => {
        setCelebrationPostData({
            Id: 0,
            Name: '',
            Content: '',
            Status: 1,
            PublishDate: new Date(),
            OrganizationTypeId: 2,
            CreatedOrUpdatedBy: '',
            OperationType: 1
        });
        setOpenNewCelebrationDialog(true);
    }

    const handleUpdateCelebration = (celebration) => {
        const date = new Date(celebration.PublishDate);
        const data = {
            ...celebration,
            OperationType: 2,
            PublishDate: date
        };
        setCelebrationPostData(data);
        setOpenNewCelebrationDialog(true);
    }



    const SetCelebration = () => {
        if (!celebrationPostData.Name) {
            setUyariTip('error');
            setResponseMessage('Kutlama adı boş olamaz.');
            setUyari(true);
            return;
        }
        if (!celebrationPostData.Content) {
            setUyariTip('error');
            setResponseMessage('Kutlama mesajı boş olamaz.');
            setUyari(true);
            return;
        }
        if (!celebrationPostData.PublishDate) {
            setUyariTip('error');
            setResponseMessage('Kutlama yayınlanacağı tarih boş olamaz.');
            setUyari(true);
            return;
        }
        setLoading(true);
        axios.post('SetCelebration', celebrationPostData)
            .then((response) => {
                if (response?.data?.ErrorCode === "0") {
                    setUyariTip('success');
                    setResponseMessage('Kutlama başarıyla kaydedildi.');
                    setUyari(true);
                    setOpenNewCelebrationDialog(false);
                    setLoading(false);
                    GetCelebration();
                }
                else {
                    setUyariTip('error');
                    setResponseMessage('Kutlama kaydedilirken bir hata oluştu.');
                    setUyari(true);
                    setLoading(false);
                }

            })
            .catch((error) => {
                setUyariTip('error');
                setResponseMessage('Kutlama kaydedilirken bir hata oluştu.');
                setUyari(true);
                setLoading(false);
            });
    }




    return (
        <React.Fragment>
            <ThemeProvider theme={theme2}>
                <Page>
                    <Backdrop className={classes.backdrop} open={loading}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Snackbar
                        open={uyari}
                        autoHideDuration={10000}
                        onClose={uyariKapat}
                        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    >
                        <Alert onClose={uyariKapat} variant={uyariTip} message={responseMessage} />
                    </Snackbar>
                    <Card >
                        <CardHeader title="Özel Gün Yönetimi" />
                        <Divider />
                        <CardContent >
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} lg={12}>
                                    <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
                                        <Button
                                            className={classes.action}
                                            variant="contained"
                                            color="secondary"
                                            onClick={handleNewCelebration}
                                        >
                                            Yeni Kutlama Ekle
                                        </Button>

                                    </Stack>
                                </Grid>
                            </Grid>
                            <TableContainer style={{ marginTop: 10 }}>
                                <Table stickyHeader aria-label="sticky table" size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell >Kutlama Adı</TableCell>
                                            <TableCell >Durum</TableCell>
                                            <TableCell >Yayınlanacağı Tarih</TableCell>
                                            <TableCell >Oluşturan Kullanıcı</TableCell>
                                            <TableCell >Oluşturma Tarihi</TableCell>
                                            <TableCell >Güncelleyen Kullanıcı</TableCell>
                                            <TableCell >Güncelleme Tarihi</TableCell>
                                            <TableCell >İşlem</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {/* <TableRow>
                                            <TableCell>Doğum Günü</TableCell>
                                            <TableCell>
                                                <Chip
                                                    label="Aktif"
                                                    color="success"
                                                    size="small"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Tooltip placement="top" title="Düzenle">
                                                    <IconButton
                                                        size="small"
                                                        style={{ backgroundColor: '#FF9800', color: 'white' }}
                                                    >
                                                        <EditIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow> */}
                                        {
                                            celebrationData.map((celebration) => (
                                                <TableRow key={celebration.Id}>
                                                    <TableCell>{celebration.Name}</TableCell>
                                                    <TableCell>
                                                        <Chip
                                                            label={celebration.Status === 1 ? "Aktif" : "Pasif"}
                                                            color={celebration.Status === 1 ? "success" : "error"}
                                                            size="small"
                                                        />
                                                    </TableCell>
                                                    <TableCell>{celebration.Locked === false ?
                                                        new Date(celebration.PublishDate).toLocaleDateString('tr-TR') :
                                                        ''
                                                    }</TableCell>
                                                    <TableCell>{celebration.CreatedBy}</TableCell>
                                                    <TableCell>{celebration.CreatedDate}</TableCell>
                                                    <TableCell>{celebration.UpdatedBy}</TableCell>
                                                    <TableCell>{celebration.UpdatedDate}</TableCell>
                                                    <TableCell>
                                                        <Stack
                                                            direction={{ xs: 'column', sm: 'row' }}
                                                            spacing={1}
                                                            alignItems="center"
                                                        >
                                                            <Tooltip placement="top" title="Düzenle">
                                                                <IconButton
                                                                    size="small"
                                                                    style={{ backgroundColor: '#FF9800', color: 'white' }}
                                                                    onClick={() => handleUpdateCelebration(celebration)}
                                                                >
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip placement="top" title="Önizleme">
                                                                <IconButton
                                                                    size="small"
                                                                    style={{ backgroundColor: '#FF9800', color: 'white' }}
                                                                    onClick={() => {
                                                                        setCelebrationMessage(celebration.Content);
                                                                        setCelebrationPostData(celebration);
                                                                        setOpenCelebrationPreviewDialog(true);
                                                                    }}
                                                                >
                                                                    <VisibilityIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Stack>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>
                </Page>
                <Dialog
                    open={openNewCelebrationDialog}
                    onClose={() => setOpenNewCelebrationDialog(false)}
                    fullWidth
                    maxWidth="md"
                    scroll="paper" // Kaydırılabilir içerik için doğru ayar
                >
                    <Card>
                        <CardHeader title={celebrationPostData.OperationType === 1 ? "Yeni Kutlama Ekle" : "Kutlama Düzenle"} />
                        <DialogContent style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} lg={12}>
                                    <TextField
                                        fullWidth
                                        label="Kutlama Başlığı"
                                        name='Name'
                                        variant="outlined"
                                        value={celebrationPostData.Name}
                                        onChange={handlePostDataChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} lg={12}>
                                    <Autocomplete
                                        options={options}
                                        getOptionLabel={(option) => option.label}
                                        name='Status'
                                        value={options.find((option) => option.value === celebrationPostData.Status)}
                                        onChange={onChangeStatus}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Durum" variant="outlined" />
                                        )}
                                        disableClearable
                                    />
                                </Grid>
                                {celebrationPostData.Locked === false && (
                                    <Grid item xs={12} sm={12} lg={12}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
                                            <DatePicker
                                                label="Başlayacağı Tarih"
                                                renderInput={(params) => <TextField {...params} fullWidth />}
                                                inputFormat="dd/MM/yyyy"
                                                fullWidth
                                                className={classes.myDatePicker}
                                                value={celebrationPostData.PublishDate}
                                                onChange={(value) => setCelebrationPostData((prevData) => ({
                                                    ...prevData,
                                                    PublishDate: value,
                                                }))}
                                                name='PublishDate'
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                )}
                                <Grid item xs={12} sm={12} lg={12}>
                                    <Alert2 severity="info">
                                        Mesajın içeriğinde Çalışan Ad ve Soyadını kullanmak için ilgili yere <b>@CalisanAdSoyad</b> yazabilirsiniz.
                                    </Alert2>
                                </Grid>
                                <Grid item xs={12} sm={12} lg={12}>
                                    <div
                                        spellCheck="false"
                                    >
                                        <ReactQuill
                                            theme="snow"
                                            placeholder="Kutlama Mesajı"
                                            name='Content'
                                            value={celebrationPostData.Content}
                                            onChange={(value) => setCelebrationPostData((prevData) => ({
                                                ...prevData,
                                                Content: value,
                                            }))}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} lg={12}>
                                    <Stack direction="row" spacing={2} justifyContent="flex-end" alignItems="center">
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => SetCelebration()}
                                        >
                                            Kaydet
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => setOpenCelebrationPreviewDialog(true)}
                                        >
                                            Önizleme
                                        </Button>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </Card>
                </Dialog>

                {
                    CelebrationMessagePreview && (
                        <CelebrationMessagePreview
                            Message={celebrationPostData.Content}
                            openCelebrationPreviewDialog={openCelebrationPreviewDialog}
                            setOpenCelebrationPreviewDialog={setOpenCelebrationPreviewDialog}
                        />
                    )
                }
            </ThemeProvider>
        </React.Fragment>
    );
};

export default CelebrationManagement;